import produce from 'immer';

import { actionTypes } from './constants';
import * as Types from './types';

export const defaultState: Types.IIdenttManualState = {
    tagsLoaded: false,
    playerTags: [],
    isLoadingError: false
};

export const reducer = (reducerSuffix: string) =>
    produce((draftState, action: Types.TIdenttManualAction): Types.IIdenttManualState | void => {
        switch (action.type) {
            case actionTypes.SET_PLAYER_TAGS:
            case actionTypes.SET_PLAYER_TAGS + reducerSuffix as actionTypes.SET_PLAYER_TAGS: {
                draftState.playerTags = [...draftState.playerTags, ...action.payload];
                draftState.tagsLoaded = true;

                break;
            }
            case actionTypes.SET_LOADING_ERROR:
            case actionTypes.SET_LOADING_ERROR + reducerSuffix as actionTypes.SET_LOADING_ERROR: {
                draftState.isLoadingError = action.payload;

                break;
            }

            default: {
                break;
            }
        }
    }, defaultState);
